const EnterBar = () => import(/* webpackChunkName:"chunk-actbar" */ '../views/P5_Activitys/ActEnterBar/index.vue')

const BeerAct = () => import(/* webpackChunkName:"chunk-beeract" */ '../views/P5_Activitys/BeerCollect')

const BlackFriday = () => import(/* webpackChunkName:"chunk-blackfriday" */ '../views/P5_Activitys/BlackFriday')

const CallMotivation = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/index.vue')
const CallMotivationRules = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/rules.vue')

// 动态页面容器
const DyPage = () => import(/* webpackChunkName:"chunk-dypage" */ '../views/P5_Activitys/DyPage/index.vue')

const EidAlFitrMainMale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actMaleMain.vue')
const EidAlFitrRankMale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actMaleRank.vue')
const EidAlFitrRecordsMale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actMaleRecords.vue')
const EidAlFitrRulesMale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actMaleRules.vue')
const EidAlFitrMainFemale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actFemaleMain.vue')
const EidAlFitrRankFemale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actFemaleRank.vue')
const EidAlFitrRulesFemale = () => import(/* webpackChunkName:"chunk-EidAlFitr" */ '../views/P5_Activitys/EidAlFitr/actFemaleRules.vue')

const HolidayMainMaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActMaleMain.vue')
const HolidayRankMaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActMaleRank.vue')
const HolidayRulesMaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActMaleRules.vue')
const HolidayMainFemaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActFemaleMain.vue')
const HolidayRankFemaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActFemaleRank.vue')
const HolidayRulesFemaleBr = () => import(/* webpackChunkName:"chunk-nationaldayBr" */ '../views/P5_Activitys/HolidayBR/holidayActFemaleRules.vue')

const Incentive = () => import(/* webpackChunkName:"chunk-incentive" */ '../views/P5_Activitys/Incentive/index.vue')
const IncentiveForNew = () => import(/* webpackChunkName:"chunk-incentivefornew" */ '../views/P5_Activitys/IncentiveForNew/index.vue')

const Liveness = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/index.vue')
const LivenessRules = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/rules.vue')

const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchingtopay" */ '../views/P5_Activitys/MatchingToPay/index.vue')

const NewguyWheelPan = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/index.vue')
const NewguyWheelPanRules = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/rules.vue')

const NineDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineDotNinetyNine" */ '../views/P5_Activitys/NineDotNinetyNine/index.vue')

const NineteenDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineteenDotNinetyNine" */ '../views/P5_Activitys/NineteenDotNinetyNine/index.vue')

const PrivateCallIncome = () => import(/* webpackChunkName:"chunk-privatecall" */ '../views/P5_Activitys/PrivateCallIncome')

const RechargeAfterFirst = () => import(/* webpackChunkName:"chunk-rechargeAfterFirst" */ '../views/P5_Activitys/RechargeAfterFirst/index.vue')

const RechargeFirst = () => import(/* webpackChunkName:"chunk-rechargefirst" */ '../views/P5_Activitys/RechargeFirst/index.vue')

const RechargeLowSmall = () => import(/* webpackChunkName:"chunk-rechargeLowSmall" */ '../views/P5_Activitys/RechargeLowSmall/index.vue')

const RechargeMidR = () => import(/* webpackChunkName:"chunk-rechargeMidR" */ '../views/P5_Activitys/RechargeRUser/midR.vue')
const RechargeTopR = () => import(/* webpackChunkName:"chunk-rechargeTopR" */ '../views/P5_Activitys/RechargeRUser/topR.vue')

const Repurchase = () => import(/* webpackChunkName:"chunk-repurchase" */ '../views/P5_Activitys/Repurchase/index.vue')

const SayHi = () => import(/* webpackChunkName:"chunk-sayhi" */ '../views/P5_Activitys/SayHi/index.vue')

const routes = [
  // 运营位
  {
    path: '/act-enter', name: 'act-enter', component: EnterBar
  },
  // 啤酒收集节
  {
    path: '/beer-collect', name: 'beer-collect', component: BeerAct
  },
  // 黑色星期五(转盘活动)
  {
    path: '/black-friday', name: 'black-friday', component: BlackFriday
  },
  // 男用户通话激励
  {
    path: '/call-motivation', name: 'call-motivation', component: CallMotivation
  },
  {
    path: '/call-motivation-rules', name: 'call-motivation', component: CallMotivationRules
  },

  // 自定义图片页面
  {
    path: '/dy-page/:customPageId', name: 'dy-page', component: DyPage
  },
  // 开斋节-2026
  {
    path: '/eidalfitr-main-male', name: 'eidalfitr-main-male', component: EidAlFitrMainMale
  },
  {
    path: '/eidalfitr-rank-male', name: 'eidalfitr-rank-male', component: EidAlFitrRankMale
  },
  {
    path: '/eidalfitr-records-male', name: 'eidalfitr-records-male', component: EidAlFitrRecordsMale
  },
  {
    path: '/eidalfitr-rules-male', name: 'eidalfitr-rules-male', component: EidAlFitrRulesMale
  },
  {
    path: '/eidalfitr-main-female', name: 'eidalfitr-main-female', component: EidAlFitrMainFemale
  },
  {
    path: '/eidalfitr-rank-female', name: 'eidalfitr-rank-female', component: EidAlFitrRankFemale
  },
  {
    path: '/eidalfitr-rules-female', name: 'eidalfitr-rules-female', component: EidAlFitrRulesFemale
  },
  // 法定节假日
  {
    path: '/holiday-main-male-br', name: 'holiday-main-male-br', component: HolidayMainMaleBr
  },
  {
    path: '/holiday-rank-male-br', name: 'holiday-rank-male-br', component: HolidayRankMaleBr
  },
  {
    path: '/holiday-rules-male-br', name: 'holiday-rules-male-br', component: HolidayRulesMaleBr
  },
  {
    path: '/holiday-main-female-br', name: 'holiday-main-female-br', component: HolidayMainFemaleBr
  },
  {
    path: '/holiday-rank-female-br', name: 'holiday-rank-female-br', component: HolidayRankFemaleBr
  },
  {
    path: '/holiday-rules-female-br', name: 'holiday-rules-female-br', component: HolidayRulesFemaleBr
  },
  {
    path: '/incentive-act', name: 'incentive-act', component: Incentive
  },
  {
    path: '/incentive-fornew', name: 'incentive-fornew', component: IncentiveForNew
  },
  // 升级奖励
  {
    path: '/liveness', name: 'liveness', component: Liveness
  },
  {
    path: '/liveness-rules', name: 'liveness-rules', component: LivenessRules
  },
  // match
  {
    path: '/matching-to-pay', name: 'matching-to-pay', component: MatchingToPay
  },
  // 新用户转盘
  {
    path: '/newguy-wheel-pan', name: 'newguy-wheel-pan', component: NewguyWheelPan
  },
  {
    path: '/newguy-wheel-pan-rules', name: 'newguy-wheel-pan', component: NewguyWheelPanRules
  },
  // 充值活动9.99
  {
    path: '/recharge-ninepointninety', name: 'nine-dot-ninetynine', component: NineDotNinetyNine
  },
  // 充值活动19.99
  {
    path: '/nineteen-ninety_nine', name: 'nineteen-dot-ninetynine', component: NineteenDotNinetyNine
  },
  // 主播限时付费电话补贴
  {
    path: '/private-call-income', name: 'private-call-income', component: PrivateCallIncome
  },
  // 充值-次充
  {
    path: '/recharge-afterfirst', name: 'recharge-afterfirst', component: RechargeAfterFirst
  },
  // 充值-首充
  {
    path: '/recharge-first', name: 'recharge-first', component: RechargeFirst
  },
  // 低频小额用户充值
  {
    path: '/recharge-low-small', name: 'recharge-low-small', component: RechargeLowSmall
  },
  // 中小R用户充值
  {
    path: '/recharge-mid-r', name: 'recharge-mid-r', component: RechargeMidR
  },
  // 大R用户充值
  {
    path: '/recharge-top-r', name: 'recharge-top-r', component: RechargeTopR
  },
  // 复购
  {
    path: '/repurchase', name: 'repurchase', component: Repurchase
  },
  // SayHi
  {
    path: '/say-hi', name: 'say-hi', component: SayHi
  }
]
export default routes
